import { Component, input } from '@angular/core';

import { CmsPicture, CmsTarget } from '@fcom/core-api';
import { AspectRatios } from '@fcom/ui-components/components/images/enums';

@Component({
  selector: 'fin-text-on-image',
  templateUrl: './text-on-image.component.html',
  standalone: false,
})
export class TextOnImageComponent {
  teaserTitle = input<string>();
  teaserText = input<string>();
  imageData = input<CmsPicture>();
  imageAspectRatio = input<keyof typeof AspectRatios>();
  target = input<CmsTarget>();
}
